import React from 'react';
import './PetAnimations.css';

export default function AxolotlSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#F8A4C8';
  const frillColor = color || '#E875A0';
  const bellyColor = '#FFF0F5';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Tail */}
      <path
        d="M82 78C92 76 102 72 108 66C110 64 108 60 104 62C98 66 90 72 82 76"
        fill={bodyColor}
        stroke="none"
      />
      <path
        d="M90 74C96 70 102 66 106 64"
        stroke={frillColor}
        strokeWidth="1"
        strokeLinecap="round"
        fill="none"
        opacity="0.5"
      />
      {/* Body */}
      <ellipse cx="58" cy="76" rx="28" ry="18" fill={bodyColor} />
      {/* Belly spots */}
      <ellipse cx="58" cy="80" rx="18" ry="12" fill={bellyColor} />
      {/* Legs */}
      <path d="M36 86L28 96L32 96L34 92" fill={bodyColor} stroke={bodyColor} strokeWidth="2" strokeLinejoin="round" />
      <path d="M38 86L30 96L34 97L36 92" fill={bodyColor} stroke={bodyColor} strokeWidth="1" strokeLinejoin="round" />
      <path d="M78 86L86 96L82 96L80 92" fill={bodyColor} stroke={bodyColor} strokeWidth="2" strokeLinejoin="round" />
      <path d="M76 86L84 96L80 97L78 92" fill={bodyColor} stroke={bodyColor} strokeWidth="1" strokeLinejoin="round" />
      {/* Front legs */}
      <path d="M40 80L30 88L34 89L38 84" fill={bodyColor} stroke={bodyColor} strokeWidth="2" strokeLinejoin="round" />
      <path d="M76 80L86 88L82 89L78 84" fill={bodyColor} stroke={bodyColor} strokeWidth="2" strokeLinejoin="round" />
      {/* Head */}
      <ellipse cx="58" cy="50" rx="24" ry="20" fill={bodyColor} />
      {/* Gills/Frills - left */}
      <path d="M34 38C26 30 22 24 24 22C26 20 30 26 34 34" fill={frillColor} />
      <path d="M34 42C24 38 18 34 18 30C18 28 24 32 34 38" fill={frillColor} />
      <path d="M36 46C28 46 20 44 18 42C18 40 26 42 36 44" fill={frillColor} />
      {/* Gills/Frills - right */}
      <path d="M82 38C90 30 94 24 92 22C90 20 86 26 82 34" fill={frillColor} />
      <path d="M82 42C92 38 98 34 98 30C98 28 92 32 82 38" fill={frillColor} />
      <path d="M80 46C88 46 96 44 98 42C98 40 90 42 80 44" fill={frillColor} />
      {/* Face */}
      <ellipse cx="58" cy="54" rx="14" ry="10" fill={bellyColor} opacity="0.5" />
      {/* Eyes - big and cute */}
      <circle cx="48" cy="46" r="6" fill="white" />
      <circle cx="68" cy="46" r="6" fill="white" />
      <circle cx="49" cy="46.5" r="4" fill="#2C2419" />
      <circle cx="69" cy="46.5" r="4" fill="#2C2419" />
      <circle cx="50.5" cy="44.5" r="1.5" fill="white" />
      <circle cx="70.5" cy="44.5" r="1.5" fill="white" />
      {/* Smile */}
      <path d="M52 55C52 55 55 58 58 58C61 58 64 55 64 55" stroke={frillColor} strokeWidth="1.2" strokeLinecap="round" fill="none" />
      {/* Cheek blush */}
      <ellipse cx="44" cy="54" rx="4" ry="2.5" fill="#F48FB1" opacity="0.4" />
      <ellipse cx="72" cy="54" rx="4" ry="2.5" fill="#F48FB1" opacity="0.4" />
    </svg>
  );
}
